import { render } from "./App.vue?vue&type=template&id=a66927e4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a66927e4&lang=css"

import exportComponent from "/data2/source/sdm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__